import React from 'react';
import { QuoteIcon } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  name: string;
  title: string;
  company?: string;
  imageSrc: string;
}
export const TestimonialCard = ({
  quote,
  name,
  title,
  company,
  imageSrc
}: TestimonialCardProps) => {
  return <div className="bg-white rounded-xl shadow-md p-6 relative" data-id="element-522">
      <QuoteIcon className="h-8 w-8 text-indigo-200 absolute top-4 right-4" data-id="element-523" />
      <div className="flex items-center mb-6" data-id="element-524">
        <img src={imageSrc} alt={name} className="h-16 w-16 rounded-full object-cover mr-4 border-2 border-indigo-100" data-id="element-525" />
        <div data-id="element-526">
          <h4 className="font-bold text-slate-800" data-id="element-527">{name}</h4>
          <p className="text-slate-600" data-id="element-528">
            {title}
            {company ? `, ${company}` : ''}
          </p>
        </div>
      </div>
      <p className="text-slate-700 italic" data-id="element-529">{quote}</p>
    </div>;
};